module.exports = __webpack_public_path__ + "static/media/dedra-white-landmark-home-warranty-review_160px.6d03f30d.jpg";